var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 8,
    fill: "#0E9B68"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 17C27 11.5161 22.4839 7 17 7C11.4758 7 7 11.5161 7 17C7 22.5242 11.4758 27 17 27C22.4839 27 27 22.5242 27 17ZM15.8306 22.3226C15.5887 22.5645 15.1452 22.5645 14.9032 22.3226L10.7097 18.129C10.4677 17.8871 10.4677 17.4435 10.7097 17.2016L11.6371 16.3145C11.879 16.0323 12.2823 16.0323 12.5242 16.3145L15.3871 19.1371L21.4355 13.0887C21.6774 12.8065 22.0806 12.8065 22.3226 13.0887L23.25 13.9758C23.4919 14.2177 23.4919 14.6613 23.25 14.9032L15.8306 22.3226Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.5c2e03ced5d577df158363bd2a4677fa.svg";
export { ForwardRef as ReactComponent };